/**
 * @see {https://github.schibsted.io/svp/web-player/blob/master/src/js/player/playback/config/chromecast.js}
 */
export const MEDIA_RECEIVER_APP_IDS = {
  vgtv: 'A5965089',
  ab: 'CB3CFFEE',
};

export type SupportedAssetProvider = keyof typeof MEDIA_RECEIVER_APP_IDS;
